module.exports = __webpack_public_path__ + "static/media/mtn25-aragon.e3bdca79.geojson";